// extracted by mini-css-extract-plugin
export default {"loading":"LoadingSpinner_loading__ZWiv0","spinner":"LoadingSpinner_spinner__d-EuI"};